/**
 * Selects the network status.
 * @returns {Selector}
 */
const getStatusNetworkSelect = state => state && state.network.status

export default getStatusNetworkSelect
